import React from "react";
import SuccessAlert from "../../components/successAlert";

// Thin wrapper — the admin-registration flow was the first use of the
// celebratory success screen; the visual is now the shared SuccessAlert and
// this file just adapts the flow-specific copy/pills onto it. Callers of the
// old <AdminSuccessModal> don't need to change.
export default function AdminSuccessModal({
  open,
  onClose,
  onDone,
  adminName = "",
  adminEmail = "",
  permission = "",
}) {
  const pills = [
    adminName && { label: adminName },
    adminEmail && { label: adminEmail },
    permission && {
      label: permission === "ADMIN" ? "Admin Access" : "HR Access",
    },
  ].filter(Boolean);

  return (
    <SuccessAlert
      open={open}
      onClose={onClose}
      title="Registration Successful!"
      description="The administrator has been onboarded and their account is now active. An email has been sent with login instructions."
      pills={pills}
      primaryLabel="Go to Dashboard"
      onPrimaryClick={onDone || onClose}
      secondaryLabel="Close"
    />
  );
}
